import { brandSiteFor, parseBrandDomains } from './site';

const raw = import.meta.env;

function str(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

const firebaseApiKey = str(raw.VITE_FIREBASE_API_KEY);
const mockFlag = str(raw.VITE_MOCK);

/** The brand domain this page is open on, when it is one (see site.ts). */
const site =
  typeof window === 'undefined'
    ? null
    : brandSiteFor(window.location.hostname, parseBrandDomains(str(raw.VITE_BRAND_DOMAINS)));

/**
 * Mock mode is on when VITE_MOCK=1, and also when nothing is configured at all,
 * so a fresh checkout runs with demo data instead of a blank screen.
 */
const mock = mockFlag === '1' || (mockFlag !== '0' && firebaseApiKey === '');

export const env = {
  mock,
  apiBaseUrl: site?.apiBaseUrl || str(raw.VITE_API_BASE_URL) || 'http://localhost:7072',
  /**
   * The Tab Service portal this app signs people out to. Sign-in for both products happens
   * there, so the way out has to go back there. Empty in mock mode and local development.
   */
  portalWebUrl: site?.portalWebUrl || str(raw.VITE_PORTAL_WEB_URL),
  /**
   * '1' once sign-in happens only at the portal. The sign-in page here then sends people
   * there instead of offering a form. Off until the portal is the single front door.
   */
  firebase: {
    apiKey: firebaseApiKey,
    authDomain: str(raw.VITE_FIREBASE_AUTH_DOMAIN),
    projectId: str(raw.VITE_FIREBASE_PROJECT_ID),
    appId: str(raw.VITE_FIREBASE_APP_ID),
  },
  get firebaseConfigured(): boolean {
    return firebaseApiKey !== '' && str(raw.VITE_FIREBASE_AUTH_DOMAIN) !== '';
  },
} as const;
